import { Directive, TemplateRef } from '@angular/core';

/** Šablona rozbaleného řádku: `<ng-template appDataTableExpand let-row="row">` */
@Directive({
  selector: '[appDataTableExpand]',
})
export class DataTableExpandDirective {
  constructor(public readonly templateRef: TemplateRef<{ row: unknown }>) {}
}
